module.exports = __webpack_public_path__ + "static/img/password.62624398.svg";